import { gql } from '@apollo/client'

import { FRAGMENT as VIDEO_FRAGMENT } from '../../components/LibraryPostVideoCard'
import { FRAGMENT as ARTICLE_FRAGMENT } from '../../components/LibraryPostArticleCard'

export const PAGES = gql`
  query PostPages {
    libraryPosts(perPage: 1000) {
      nodes {
        ... on LibraryPostArticle {
          id
          slug
        }

        ... on LibraryPostVideo {
          id
          slug
        }
      }
    }
  }
`

export const POST = gql`
  query Post($slug: String!, $status: LibraryPostStatus) {
    libraryPost(slug: $slug, status: $status) {
      ... on LibraryPostArticle {
        id
        slug
        title
        body
        image {
          url
          width
          height
          blurhash
        }
        imageCropped {
          url
          width
          height
          blurhash
        }
        topics {
          nodes {
            slug
            title
          }
        }
        guides {
          nodes {
            id
            slug
            title
            posts {
              ... on LibraryPostArticle {
                id
                slug
              }
              ... on LibraryPostVideo {
                id
                slug
              }
            }
          }
        }
        illustratorName
        illustratorUrl
        publishedAt
        intro
        description
        author {
          name
          url
          description
        }
        collections(perPage: 1, type: SERIES) {
          nodes {
            id
            slug
            title
            posts {
              nodes {
                ... on LibraryPostArticle {
                  ...LibraryPostArticleCardComponent
                }
                ... on LibraryPostVideo {
                  ...LibraryPostVideoCardComponent
                }
              }
            }
          }
        }
        relatedPosts(perPage: 3) {
          nodes {
            ... on LibraryPostArticle {
              ...LibraryPostArticleCardComponent
            }
            ... on LibraryPostVideo {
              ...LibraryPostVideoCardComponent
            }
          }
        }
      }
      ... on LibraryPostVideo {
        id
        slug
        title
        image {
          url
          width
          height
        }
        publishedAt
        intro
        description
        wistiaId
        transcripts {
          englishName
          language
          nativeName
          text
        }
        guides {
          nodes {
            id
            slug
            title
            posts {
              ... on LibraryPostArticle {
                id
                slug
              }
              ... on LibraryPostVideo {
                id
                slug
              }
            }
          }
        }
        topics {
          nodes {
            slug
            title
          }
        }
        demoUrl
        duration
        difficultyLevel
        author {
          name
          url
          description
        }
        next {
          ...LibraryPostVideoCardComponent
        }
        previous {
          ...LibraryPostVideoCardComponent
        }
        collections(perPage: 1, type: SERIES) {
          nodes {
            id
            slug
            title
            posts {
              nodes {
                ... on LibraryPostArticle {
                  ...LibraryPostArticleCardComponent
                }
                ... on LibraryPostVideo {
                  ...LibraryPostVideoCardComponent
                }
              }
            }
          }
        }
        relatedPosts(perPage: 3) {
          nodes {
            ... on LibraryPostArticle {
              ...LibraryPostArticleCardComponent
            }
            ... on LibraryPostVideo {
              ...LibraryPostVideoCardComponent
            }
          }
        }
      }
    }
  }

  ${VIDEO_FRAGMENT}
  ${ARTICLE_FRAGMENT}
`
